import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';
import {AuthGuard} from './auth.guard';
import {AuthService} from './auth.service';

@Injectable()
export class AuthWithTokenGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
        private authGuard: AuthGuard,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> {
        const hasToken = route.queryParamMap.has('token');

        const beforeAuth$ = hasToken
            ? this.authService.authorizeByToken(route.queryParams['token']).pipe(
                catchError(() => of(null))
            )
            : of(null);

        return beforeAuth$.pipe(
            map(() => this.authGuard.canActivate()),
            map(authGuardResult =>
                authGuardResult === true && hasToken
                    ? this.removeQueryParamsFromUrl(state)
                    : authGuardResult
            )
        );
    }

    private removeQueryParamsFromUrl(state: RouterStateSnapshot): UrlTree {
        const urlWithoutQueryParams = state.url.replace(/\?.*$/, '');

        return this.router.parseUrl(urlWithoutQueryParams);
    }

}
